// Lightweight SEO helper for a client-rendered app. Pages call
// useDocumentMeta() (see src/hooks/useDocumentMeta.ts) with the values
// returned here to set <title> and the description meta tag on mount.
//
// Note: because this is a client-side rendered SPA, search engines and
// social crawlers that don't execute JavaScript will only see the
// defaults baked into index.html. If SEO/social-preview accuracy per
// route matters, consider prerendering (e.g. vite-plugin-ssr,
// react-snap) or moving this route back onto a server-rendered
// framework — noted in the README.

export function pageSeo(title: string, description: string) {
  return {
    title: `${title} | The Planet`,
    description,
  };
}
